if (!customElements.get('product-card-rating')) {
  class ProductsRating extends HTMLElement {
    constructor() {
      super();
      this.spanElements = this.querySelectorAll('.ruk-rating-snippet-count');
      if (this.spanElements) {
        this.handleRating();
      }
      this.ratingWrappers = document.querySelectorAll('[data-card-rating]');
      this.ratingWrappers.forEach((ratingWrapper) => {
        if (ratingWrapper.textContent.trim() === '') {
          const card = ratingWrapper.closest('.product-card-rating');
          if (card) {
            card.style.display = 'none';
          }
        }
      });
    }
    connectedCallback() {
      if (this.spanElements) {
        this.handleRating();
      }
      this.ratingWrappers = document.querySelectorAll('[data-card-rating]');
      this.ratingWrappers.forEach((ratingWrapper) => {
        if (ratingWrapper.textContent.trim() === '') {
          const card = ratingWrapper.closest('.product-card-rating');
          if (card) {
            card.style.display = 'none';
          }
        }
      });
    }
    handleRating() {
      this.spanElements.forEach((spanElement) => {
        const text = spanElement.textContent.trim();
        const parts = text.split('/');
        if (parts.length === 2) {
          const ratingParts = parts[0].split('.');
          if (ratingParts.length === 2) {
            parts[0] = ratingParts[0] + '.' + ratingParts[1].charAt(0);
          }
          if (parts[1].includes('.00')) {
            parts[1] = parts[1].replace('.00', '');
          }
          spanElement.textContent = parts.join('/');
        }
      });
    }
  }
  customElements.define('product-card-rating', ProductsRating);
}
